module.exports = __webpack_public_path__ + "static/media/title-aircraft.669afe21.svg";